/* BNA free mini keychain: auto-adds the matching keychain once the art in the cart reaches the threshold. */
(() => {
  const THRESHOLD = 5000; // cents
  const MAP = {
    'passion-fruit': 67823563112525,
    'glass-original-canvas-art-print': 67823625371725
  };
  const KC_IDS = Object.values(MAP);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const onCart = /\/cart\/?$/.test(location.pathname);
  let busy = false;

  const post = (url, body) =>
    fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });

  const lockRows = () => {
    if (!onCart) return;
    document.querySelectorAll('.cart-item').forEach((row) => {
      const link = row.querySelector('a[href*="/products/mini-"]');
      if (!link || !/keychain/i.test(link.textContent + link.href)) return;
      row.querySelectorAll('quantity-popover, quantity-input, cart-remove-button, .cart-item__quantity-wrapper').forEach((el) => (el.style.display = 'none'));
      const name = row.querySelector('.cart-item__name');
      if (name && !row.querySelector('.bna-kc-tag')) name.insertAdjacentHTML('afterend', '<div class="bna-kc-tag" style="display:inline-block;margin-top:6px;padding:2px 8px;border-radius:999px;background:#FFF7E0;border:1px dashed #E8A317;color:#3a2a00;font-size:12px;font-weight:600">🎁 Free gift</div>');
    });
  };

  const sync = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await (await fetch(root + 'cart.js')).json();
      const kcLines = cart.items.filter((i) => KC_IDS.includes(i.variant_id));
      const artLines = cart.items.filter((i) => MAP[i.handle]);
      const artTotal = artLines.reduce((s, i) => s + i.final_line_price, 0);
      let changed = false;

      if (artTotal >= THRESHOLD && artLines.length) {
        if (!kcLines.length) {
          const top = artLines.slice().sort((a, b) => b.final_line_price - a.final_line_price)[0];
          const r = await post('cart/add.js', { items: [{ id: MAP[top.handle], quantity: 1, properties: { _bna_gift: '1' } }] });
          changed = r.ok;
        } else {
          for (const [n, l] of kcLines.entries()) {
            const want = n === 0 ? 1 : 0;
            if (l.quantity !== want) { await post('cart/change.js', { id: l.key, quantity: want }); changed = true; }
          }
        }
      } else {
        for (const l of kcLines) {
          if (l.properties && l.properties._bna_gift) { await post('cart/change.js', { id: l.key, quantity: 0 }); changed = true; }
        }
      }

      if (changed) {
        if (onCart) { location.reload(); return; }
        const c2 = await (await fetch(root + 'cart.js')).json();
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((s) => (s.textContent = c2.item_count));
      }
      lockRows();
    } catch (e) {
      /* never block shopping */
    } finally {
      busy = false;
    }
  };

  const start = () => {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(sync, 400));
    if (onCart) new MutationObserver(lockRows).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
